import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useInventObjectLink = defineStore('invent_object_link', () => {
  const open = ref<boolean>(false)

  const data = ref({
    object_from: 0,
    object_to: 0,
    object_type: 3,
  })

  /**
   * Функция сброса данных
   */
  const closeForm = () => {
    data.value = {
      object_from: 0,
      object_to: 0,
      object_type: 3,
    }

    open.value = false
  }

  return {
    open,
    data,

    closeForm,
  }
})
